import React from "react";
import styles from "./AIEntryPortal.module.scss";
import agent2 from "./agent-2.gif";

export default function AIPortalLogo({ size = "default", className = "" }) {
  const sizeClass = size === "large" ? styles.chatLogoLarge : "";
  return (
    <div className={`${styles.chatLogo} ${sizeClass} ${className}`} aria-hidden>
      <img src={agent2} alt="" className={styles.chatLogoImg} />
    </div>
  );
}
